import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tool-header-button-item__dropdown"
}
const _hoisted_2 = ["onClick"]

import {
  withDefaults,
  defineOptions,
  watch,
} from "vue";

interface Props {
  dropdownItems: any[];
  isOpen: boolean;
}

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'tool-header-button-dropdown',
  props: {
    dropdownItems: {},
    isOpen: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props;






watch(
  () => props.isOpen,
  () => {
    if (props.isOpen) {
      setTimeout(() => {
        document.body.addEventListener("click", close);
      }, 10);
    }
  }
);

const close = () => {
  document.body.removeEventListener("click", close);
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dropdownItems, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.label,
            onClick: 
        () => {
          item.clickEvent();
          close();
        }
      ,
            class: "tool-header-button-item__dropdown-item"
          }, _toDisplayString(item.label), 9, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})